import { ref, computed, watchEffect } from 'vue';

// PC 端主题三态：auto（跟随浏览器 prefers-color-scheme）/ light / dark。
// 持久化 localStorage dp_theme；isDark 驱动两件事：
//   1. App.vue a-config-provider theme.algorithm（AntD 组件，经 MF singleton 穿透插件 remote）
//   2. html[data-theme] 属性（自绘 CSS 走 --dp-* 变量，见 theme.css）
const stored = localStorage.getItem('dp_theme');
export const themeMode = ref(stored === 'light' || stored === 'dark' ? stored : 'auto');

// 系统偏好用 ref 承接（matchMedia.matches 非响应式，change 事件回写才能触发重算）
const mq = window.matchMedia('(prefers-color-scheme: dark)');
const systemDark = ref(mq.matches);
mq.addEventListener('change', (e) => { systemDark.value = e.matches; });

export const isDark = computed(() =>
  themeMode.value === 'dark' || (themeMode.value === 'auto' && systemDark.value)
);

export function setThemeMode(mode) {
  themeMode.value = mode;
  localStorage.setItem('dp_theme', mode);
}

// 模式/系统任一变化即同步 html[data-theme]（驱动 --dp-* CSS 变量切换）
watchEffect(() => {
  document.documentElement.dataset.theme = isDark.value ? 'dark' : 'light';
});
